import { Http, RequestOptionsArgs, Response, RequestOptions, Headers } from "@angular/http";
import { Observable, Subscription } from "rxjs/Rx";
//import { Result, ResultEmpty, ResultStatus } from "@app/models";
//import { Toastr, TOASTR_TOKEN } from "@app/common";
import { Injectable } from '@angular/core';
import { NotificationsService } from "@varsity/services";
import { LoggingService } from "../logging/logging.service";
//import { Observable } from 'rxjs/Observable';

@Injectable()
export class HttpHelperService {
    

    constructor(
        private http: Http,
        private loggingService: LoggingService,
        private notificationsService: NotificationsService
        //@Inject(TOASTR_TOKEN) private toastr: Toastr
    ) {
    }

    /**
     * Construct a GET request which interprets the body as JSON and returns it.
     *
     * @return an `Observable` of the body as type `T`.
     */
    get<T>(url: string, options?: RequestOptionsArgs): Observable<T> {
        options = this.autoConfigureRequest(options);

        let promise = this.http
            .get(url, options)
            .share();
        this.attachErrorHandler(promise);
        return promise.map(response => {
            const data: T = response.json();
            return data;
        });
    }
   
    /**
     * Construct a POST request which interprets the body as JSON and returns it.
     *
     * @return an `Observable` of the body as type `T`.
     */
    post<T>(url: string, body: any, options?: RequestOptionsArgs): Observable<T> {
        options = this.autoConfigureRequest(options);

        let promise = this.http.post(url, body, options).share();
        this.attachErrorHandler(promise);
        return promise.map(response => {
            const data: T = response.json();
            return data;
        });
    }

    /**
     * Construct a PUT request which interprets the body as JSON and returns it.
     *
     * @return an `Observable` of the body as type `T`.
     */
    put<T>(url: string, body: any, options?: RequestOptionsArgs): Observable<T> {
        options = this.autoConfigureRequest(options);

        let promise = this.http.put(url, body, options).share();
        this.attachErrorHandler(promise);
        return promise.map(response => {
            const data: T = response.json();
            return data;
        });
    }

    private attachErrorHandler(promise: Observable<Response>) {
        let subscription: Subscription;

        let timeout = setTimeout(() => {
            clearTimeout(timeout);
            if (subscription) {
                subscription.unsubscribe();
            }

            this.notificationsService.notifyRequestCompleted();
        }, 30000);

        subscription = promise.finally(() => {
            clearTimeout(timeout);
            this.notificationsService.notifyRequestCompleted();
            subscription.unsubscribe();
        }).subscribe(p => {
            const { status = 0 } = p;
            if (status !== 200) {
                this.loggingService.warn('request did not return 200');
            }
        }, (error) => {
            this.loggingService.error(error);
        });
    }

    private autoConfigureRequest(options?: RequestOptionsArgs): RequestOptionsArgs {
        this.notificationsService.notifyRequestStarted();

        let headers = new Headers({ 'Content-Type': 'application/json' });
        if (!options) {
            options = new RequestOptions();
        }
        options.headers = headers;
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/services/http-service/http.service.ts